import { memo } from 'react'


const CreativeLibrary = memo(() => {

    return(
        <div className="mt-2">
            <h1>Campaign / media-buying / Creatives / Creative Library</h1>

        </div>
    )

})


export default CreativeLibrary